import { render, staticRenderFns } from "./FormFieldLabel.vue?vue&type=template&id=768372dc&"
import script from "./FormFieldLabel.vue?vue&type=script&lang=js&"
export * from "./FormFieldLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports